// التعرّف الصوتي الأصلي للجهاز (iOS/Android) عبر Capacitor — بلا ذكاء اصطناعي ولا خادم.
let plugin = null;
const load = async () => {
  if (!plugin) ({ SpeechRecognition: plugin } = await import("@capgo/capacitor-speech-recognition"));
  return plugin;
};

export const nativeStart = async (lang, onPartial) => {
  const SR = await load();
  await SR.requestPermissions();
  await SR.removeAllListeners();
  await SR.addListener("partialResults", (e) => {
    if (e?.matches?.length) onPartial(e.matches[0]);
  });
  await SR.start({ language: lang, partialResults: true, popup: false });
};

export const nativeStop = async () => {
  const SR = await load();
  try { await SR.stop(); } catch { /* قد تكون متوقفة أصلاً */ }
  try { await SR.removeAllListeners(); } catch { /* تجاهل */ }
};
